module.exports = __webpack_public_path__ + "c0a275dd9653716a5f14b76c69cc2623.svg";